import { CreatorIntegrationsApiClient } from '@fourthwall/services/dist/CreatorIntegrationsApiClient'
import { createMutationHook } from '@fourthwall/utils/dist/queries'

export const useUpdateTiktokShopConfigurationMutation = createMutationHook(
  CreatorIntegrationsApiClient.updateTiktokPartnerConfiguration,
  {
    mutationKey: ['updateTiktokShopConfiguration'],
  },
)
